<template>
  <div class="mt-3.5 overflow-hidden rounded-xl border" :class="panel.border">
    <div
      class="flex items-center justify-between gap-x-3 px-4 py-2.5"
      :class="[panel.banner, panel.text]"
    >
      <div class="max-w-[120px] text-[12px] leading-[15px] font-medium">
        Overall potential infringement match
      </div>
      <span class="shrink-0 text-[20px] leading-[26px] font-medium">
        {{ panel.label }}
      </span>
    </div>
    <div class="bg-white p-4">
      <p class="text-[14px] leading-5 text-gray-800">{{ panel.body }}</p>
      <p class="mt-3.5 text-center text-[14px] leading-5 text-gray-600">
        Get the report to see full findings
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LevelPanel } from './levels'

defineProps<{ panel: LevelPanel }>()
</script>
